import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var logoListBehavior = function logoListBehavior() {
  Alpine.data('logoListBehavior', function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return {
      carousel: undefined,
      size: size,
      init: function init() {
        this.initSlider();
      },
      initSlider: function initSlider() {
        if (this.carousel === undefined) {
          if (size === 1) {
            this.carousel = new Splide(this.$el, {
              perPage: 5,
              omitEnd: true,
              rewind: true,
              gap: '2em',
              breakpoints: {
                640: {
                  perPage: 3,
                  padding: '1em',
                  gap: '1em',
                  focus: 0
                },
                480: {
                  perPage: 2,
                  padding: '0em',
                  gap: '1em'
                }
              }
            });
          } else if (size === 2) {
            this.carousel = new Splide(this.$el, {
              perPage: 4,
              omitEnd: true,
              rewind: true,
              gap: '2em',
              breakpoints: {
                640: {
                  perPage: 2,
                  padding: '1em',
                  gap: '1em',
                  focus: 0
                },
                480: {
                  perPage: 1,
                  padding: '0em',
                  gap: '1em'
                }
              }
            });
          } else {
            this.carousel = new Splide(this.$el, {
              perPage: 6,
              omitEnd: true,
              rewind: true,
              gap: '2em',
              breakpoints: {
                640: {
                  perPage: 3,
                  padding: '1em',
                  gap: '1em',
                  focus: 0
                },
                480: {
                  perPage: 2,
                  padding: '0em',
                  gap: '1em'
                }
              }
            });
          }
          this.carousel.mount();
        }
      }
    };
  });
};